const borderRadius = {
    extraSmall: '6px',
    small: '8px',
    regular: '10px',
    large: '12px',
    extraLarge: '24px',
};
export default borderRadius;
